import {WorkingSureFlowLoop} from './working-sure-flow-loop';
import {WorkingSureFlowUnit} from './working-sure-flow-unit';

export class SureFlowWorkingRatingInput {

  readonly loop: WorkingSureFlowLoop;
  readonly units: WorkingSureFlowUnit[];

  constructor(loop: WorkingSureFlowLoop, units: WorkingSureFlowUnit[]) {
    this.loop = JSON.parse(JSON.stringify(loop));
    this.units = JSON.parse(JSON.stringify(units));
  }

}
